.notice {
  margin: var(--sizes-spacing-2) 0;
}
